import { FEATURES } from '@constants/Text'
import { registrar } from '@modules/aawz-intelligence-v2/ui-registry'
import registryTarefas from './ia/registry'
import * as tarefasStore from './store'

export function tarefasModule({ store }) {
  if (typeof store.hasModule === 'function' && store.hasModule('tarefas')) {
    return
  }

  store.registerModule('tarefas', {
    ...tarefasStore,
    namespaced: true,
  })

  // Os dois cartões do módulo dentro da conversa (spec-010 do
  // `project-plataforma-por-chat`, [T016]): o MÓDULO se registra e o agregado
  // só consulta — é o que permite o `chat-message.vue` desenhar uma lista de
  // tarefas sem importar nada daqui.
  //
  // Aqui, e não numa view: o cartão pode chegar em QUALQUER conversa, e
  // registrar na view deixaria o mesmo `tool_result` virar cartão numa tela e
  // `fallback-card` na outra. `registerAllModules` roda uma vez, no boot, antes
  // de qualquer thread montar.
  //
  // Depois da guarda de `hasModule` de propósito: `registrar` RECUSA chave
  // repetida (por desenho — override silencioso entre módulos é bug), e uma
  // segunda chamada de `tarefasModule` no mesmo contexto estouraria aqui.
  registrar(registryTarefas)
}

export const PERMISSION = FEATURES.TASK_V2
